"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logMsg = exports.logger = void 0;
const mainPackageInfo = __importStar(require("../package.json"));
const logger_1 = require("../lib/logger");
let logLevel = 'info';
try {
    logLevel = process.env.LOG_LEVEL || 'info';
}
catch (error) {
    console.log('logLevel is set to \'info\' by default');
}
exports.logger = (0, logger_1.initLogger)({ name: mainPackageInfo.name }, logLevel);
const logMsg = (msg, fields) => {
    const message = fields ? { time: new Date(), msg, fields } : { time: new Date(), msg };
    console.log(JSON.stringify(message));
};
exports.logMsg = logMsg;
